// extracted by css-extract-rspack-plugin
export default {"cls1":"Stats-cls1_XHZ","cls2":"Stats-cls2_cb5 Stats-cls1_XHZ"};